import { useCallback } from 'react';
import useCustomToast from './useCustomToasts';

/**
 * Estados posibles para las notas rápidas.
 */
export const ESTADOS_QUICK_NOTES = {
  BLOQUEADO: 'bloqueado',
  OFFLINE: 'offline',
  ACTIVO: 'activo',
};

export const ERROR_TYPE = 'QuickQuotes';

/**
 * Estados restringidos para las notas rápidas.
 */
export const ESTADOS_RESTRINGIDOS_QUICK_NOTES = [ESTADOS_QUICK_NOTES.BLOQUEADO, ESTADOS_QUICK_NOTES.OFFLINE];

const useQuickNotes = () => {
  const { addWarningToast } = useCustomToast();

  /**
   * Valida la respuesta y muestra un toast de advertencia si es necesario.
   * @param {Object} respuesta - La respuesta a validar.
   * @param {Function} callback - Función a ejecutar si la respuesta es válida.
   */
  const validarRespuesta = useCallback(
    (respuesta) => {
      console.log('RESPUESTA: ', respuesta?.detail?.estado);
      if (
        respuesta?.transaccion === false &&
        respuesta?.errorType === ERROR_TYPE &&
        ESTADOS_RESTRINGIDOS_QUICK_NOTES.includes(respuesta?.detail?.estado)
      ) {
        addWarningToast(respuesta?.detail?.message);
        throw new Error(respuesta?.detail?.message);
      }
    },
    [addWarningToast]
  );

  return { validarRespuesta };
};

export default useQuickNotes;
